/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'signal': {
    width: 200.391,
    height: 200,
    viewBox: '0 0 1026 1024',
    data: '<defs/><path pid="0" d="M235.27 949.6h-74.263V606.207a353.394 353.394 0 0 1 706.788 0v343.395H235.303zm304.727-554.065L365.672 682.209h139.412l-34.913 215.006L644.496 610.54H505.084l34.913-215.005zM807.355 80.569a34.367 34.367 0 0 1 12.525 46.857L757.22 236.26l-59.211-34.128 62.625-108.8a34.128 34.128 0 0 1 46.516-12.627h.205zM514.333.027a35.834 35.834 0 0 1 37.063 34.537v123.304h-74.16V34.496A35.8 35.8 0 0 1 514.333.027zM221.516 80.603a34.128 34.128 0 0 1 46.72 12.525l62.66 108.8-59.212 34.127-62.762-108.731a34.128 34.128 0 0 1 12.525-46.755zM7.124 295.608a34.128 34.128 0 0 1 46.687-12.524l108.56 62.897-34.127 59.349L19.65 342.364a34.128 34.128 0 0 1-12.525-46.756zm1014.622 0a34.367 34.367 0 0 1-12.525 46.858l-108.527 62.795-34.128-59.382 108.527-62.864a34.128 34.128 0 0 1 46.619 12.389v.204zM39.92 949.601h949.096a37.131 37.131 0 1 1 0 74.262H39.921a37.131 37.131 0 1 1 0-74.262z" _fill="#cdcdcd"/>'
  }
})



// WEBPACK FOOTER //
// ./src/views/icons/signal.js